// Shared 0-100 integer percent <-> 0-1 float conversion for every
// ConfidenceSlider consumer (document-types' field acceptance, product-types'
// output_resolution min_confidence) - the schema always stores confidence as
// a 0-1 float; ConfidenceSlider always operates in 0-100 percent.
export function toPercent(fraction: number): number {
  return Math.round(fraction * 100)
}

export function fromPercent(percent: number): number {
  return Math.round(percent) / 100
}
